import React from 'react';
import { Box, SxProps, useTheme } from '@mui/material';
import { makeTransition } from 'shared/lib/utils/utils';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import { undefinedOnTouchDevice } from 'shared/lib/utils/globalUtils';

export default function SectionWidgetContainer({
  children,
  onClick,
  sx,
  isHover,
  setIsHover,
}: {
  children: React.ReactNode;
  onClick: () => void;
  sx?: SxProps;
  isHover: boolean;
  setIsHover: (val: boolean) => void;
}) {
  const theme = useTheme();
  const { isLessLaptop } = useBooleanScreens();

  const bgcolor = isHover
    ? `${theme.palette.primary.tonalHover} !important`
    : 'inherit';

  const borderColor = isHover ? 'transparent' : theme.palette.custom.lightGrey;

  const borderRadius = isLessLaptop ? '16px' : '20px';

  return (
    <Box
      onClick={onClick}
      onMouseEnter={undefinedOnTouchDevice(() => setIsHover(true))}
      onMouseLeave={undefinedOnTouchDevice(() => setIsHover(false))}
      sx={{
        'position': 'relative',
        'display': 'flex',
        'cursor': 'pointer',
        'flexDirection': 'column',
        'alignItems': 'flex-start',
        'justifyContent': 'flex-start',
        bgcolor,
        'overflow': 'hidden',
        'border': 1,
        'borderColor': borderColor,
        'borderRadius': borderRadius,
        'height': defaultSpacingPresets.controls.sectionWidget.h,
        'padding': isLessLaptop ? '16px' : '24px',
        'paddingBottom': isLessLaptop ? '8px' : '16px',
        'boxShadow': 'none',
        'transition': makeTransition(['background-color']),
        '& *': {
          transition: makeTransition(['color', 'border-color', 'opacity']),
        },
        ...sx,
      }}
      data-testid={'section-button-navigate'}
    >
      {children}
    </Box>
  );
}
